var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4909AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3793 7.55103L16.7772 6.2229L15.4491 5.62082L16.7772 5.01874L17.3793 3.69061L17.9814 5.01874L19.3095 5.62082L17.9814 6.2229L17.3793 7.55103ZM8.84388 7.55103L8.24179 6.2229L6.91367 5.62082L8.24179 5.01874L8.84388 3.69061L9.44596 5.01874L10.7741 5.62082L9.44596 6.2229L8.84388 7.55103ZM17.3793 16.0864L16.7772 14.7583L15.4491 14.1562L16.7772 13.5542L17.3793 12.226L17.9814 13.5542L19.3095 14.1562L17.9814 14.7583L17.3793 16.0864ZM6.31158 18.3708L4.62929 16.6885C4.49943 16.5587 4.4286 16.4081 4.41679 16.237C4.40499 16.0658 4.47582 15.9035 4.62929 15.75L12.598 7.78124C12.7397 7.63957 12.9109 7.56874 13.1116 7.56874C13.3123 7.56874 13.4835 7.63957 13.6251 7.78124L15.2189 9.37499C15.3605 9.51665 15.4314 9.68783 15.4314 9.88853C15.4314 10.0892 15.3605 10.2604 15.2189 10.4021L7.25013 18.3708C7.10846 18.5125 6.95204 18.5833 6.78085 18.5833C6.60967 18.5833 6.45325 18.5125 6.31158 18.3708V18.3708ZM6.71888 17.3614L12.2616 11.8187L11.1637 10.7208L5.62096 16.2635L6.71888 17.3614Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalize);
export default __webpack_public_path__ + "static/media/personalize.0fc1207da5caa4b025a6c701634ff58b.svg";
export { ForwardRef as ReactComponent };